import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

class PartnerRoleList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "PartnerRoleList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {header: 'Kód', width: 1, sortable, filterable},
                    "name": {header: 'Megnevezés', width: 11, sortable, filterable},
                }}
                orderBy={{field: componentConfig.idfield, direction: "ASC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default PartnerRoleList;
